import React, { useState } from 'react'
import { PatientHistoryType } from 'src/graphql.generated'
import { useSubmitPatientHistory } from '../../../../api/useSubmitPatientHistory'
import {
  FieldGrid,
  FieldSection,
  FormActions,
  LabeledDate,
  LabeledRadioGroup,
  todayIso,
  useRequiredFields,
} from '../../../fieldPrimitives'

type Reason = 'PATIENT_DID_NOT_SHOW_UP' | 'PATIENT_CANCELLED'

export const REASON_OPTIONS: { value: Reason; label: string }[] = [
  { value: 'PATIENT_DID_NOT_SHOW_UP', label: 'Participant did not show up' },
  { value: 'PATIENT_CANCELLED', label: 'Participant cancelled < 24h before' },
]

const MissedIntakeCallFields = ({ uid }: { uid: string }) => {
  const [date, setDate] = useState(todayIso())
  const [reason, setReason] = useState<Reason | ''>('')
  const { submit, submitting, error } = useSubmitPatientHistory(uid)
  const required = useRequiredFields({ 'Date of event': Boolean(date), Reason: Boolean(reason) })

  const onSubmit = async () => {
    if (!required.attempt()) {
      return
    }

    await submit({ date, type: PatientHistoryType.MissedIntakeCall, value: { reason } })
    setReason('')
    required.reset()
  }

  return (
    <FieldSection>
      <FieldGrid>
        <LabeledDate
          label="Date of event"
          value={date}
          onChange={setDate}
          required
          error={required.error('Date of event')}
        />
      </FieldGrid>
      <LabeledRadioGroup
        label="Reason"
        value={reason}
        onChange={setReason}
        options={REASON_OPTIONS}
        required
        error={required.error('Reason')}
      />
      <FormActions onSubmit={onSubmit} disabled={false} submitting={submitting} error={error} />
    </FieldSection>
  )
}

export default MissedIntakeCallFields
